import React from 'react';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//style
import styles from 'src/asset/scss/component/emptyData.module.scss'
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default React.memo(function EmptyData(props) {
    const { content } = props;//props

    return (
        <div className={styles.emptyDataContainer}>
            <FontAwesomeIcon icon="fa-solid fa-notes" />
            {/* <FontAwesomeIcon icon="fa-solid fa-file" /> */}
            <h1>조회 결과가 없어요.</h1>
            <p>{content} 여기에 표시됩니다.</p>
        </div>
    );
});